import mixpanel from "mixpanel-browser";
import { EVENTS } from "./mixpanelEvents";

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || "9ae26f10c53f64184359abcb686768b7";

mixpanel.init(MIXPANEL_TOKEN, {
  track_pageview: false,
});

// Track custom events
export const trackEvent = (eventName, properties = {}) => {
  mixpanel.track(eventName, properties);
};

// Track page views
export const trackPageView = (pageName) => {
  mixpanel.track(EVENTS.PAGE_VIEW, { page: pageName });
};

// Track link clicks
export const trackLinkClick = (linkName, url) => {
  mixpanel.track(EVENTS.LINK_CLICK, { link_name: linkName, url });
};

// Track navigation
export const trackNavigation = (from, to) => {
  mixpanel.track(EVENTS.NAVIGATION, { from, to });
};

export default mixpanel;
